import { baseApi } from '../api/baseApi';
import { setHasAccessData, setHasAccessError, setHasAccessLoading } from '../store/slices/hasAccessSlice';
import { setUser, setUserError, setUserLoading } from '../store/slices/userSlice';
export const userApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getUserByDocument: builder.query({
            query: ({ documentType, documentNumber }) => ({
                url: '/users/by-document',
                method: 'GET',
                params: { documentType, documentNumber },
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object' && 'data' in response) {
                    return response.data;
                }
                return response;
            },
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(setUserLoading(true));
                try {
                    const { data } = await queryFulfilled;
                    const userData = data;
                    dispatch(setUser({ user: userData }));
                    dispatch(setUserError(null));
                }
                catch (error) {
                    const errorMessage = error instanceof Error ? error.message : 'Failed to fetch user';
                    dispatch(setUserError(errorMessage));
                }
                finally {
                    dispatch(setUserLoading(false));
                }
            },
            providesTags: ['User'],
        }),
        hasAccess: builder.query({
            query: ({ documentType, documentNumber }) => ({
                url: '/v1/onboarding/has-access',
                method: 'GET',
                params: { documentType, documentNumber },
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object' && 'result' in response) {
                    const apiResponse = response;
                    return apiResponse.result[0] || null;
                }
                return response;
            },
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(setHasAccessLoading(true));
                try {
                    const { data } = await queryFulfilled;
                    if (data) {
                        dispatch(setHasAccessData({
                            data,
                            documentNumber: arg.documentNumber,
                        }));
                    }
                    dispatch(setHasAccessError(null));
                }
                catch (error) {
                    const errorMessage = error instanceof Error ? error.message : 'Failed to check access';
                    dispatch(setHasAccessError(errorMessage));
                }
                finally {
                    dispatch(setHasAccessLoading(false));
                }
            },
            providesTags: ['User'],
        }),
    }),
});
export const { useGetUserByDocumentQuery, useLazyGetUserByDocumentQuery, useHasAccessQuery, useLazyHasAccessQuery } = userApi;
